export default {
  common: {
    login: '登入',
    logout: '登出',
    support: '支援',
    privacy: '隱私權政策',
    terms: `服務條款`,
    and: '還有',
    guest: '客人',
    play: '開始遊戲',
    install: '安裝',
  },
  support: {
    title: `需要支援嗎？`,
    description: `如果您是這款遊戲的使用者，而且遇到了困難，
      我們會很樂意提供幫助並解答所有疑問。`,
    button: '@:common.support',
  },
  homescapes: {
    title: '夢幻家園',
    caption: '幫助管家奧斯汀將溫暖和舒適帶回他家的豪宅。',
    description: `幫助管家奧斯汀將溫暖和舒適帶回
      他家的豪宅。一起來吧，冒險
      在踏進門的時刻就將開始！`,
  },
  cookie: {
    message: '這一網站使用信息記錄程序以確保您獲得最佳體驗',
    link: `更多資訊`,
    button: '接受',
  },
  install: {
    title: '@:common.install',
    text: `在桌面上暢玩《夢幻家園》！
    安裝遊戲的網路版本，只需點擊幾下即可探訪奧斯汀！`,
    button: '@:common.install',
  },
  copy: {
    xsolla: 'Xsolla 公司是《夢幻家園》遊戲授權的全球經銷商',
  },
  game: {
    notSupported: `不支持移動裝置。請用電腦登入進行遊戲。`,
  },
};
